import axios from '@/utils/axios';

const Permissions = {
  isLoaded: false,
  canCreateProposal: false,
  canCreateQuotation: false,
  canCreateProforma: false,
  canCreateInvoice: false,
  canCreateSampling: false,
  canCreateSalesOrder: false,

  async init(){
   try{
    const response = await axios.get('/users/admin-permission');
    const data = response.data.data;
    this.canCreateProposal = data.can_create_proposal;
    this.canCreateQuotation = data.can_create_quotation;
    this.canCreateProforma = data.can_create_proforma_invoice;
    this.canCreateInvoice = data.can_create_invoice;
    this.canCreateSampling = data.can_create_sampling;
    this.canCreateSalesOrder = data.can_create_sales_order;
   }catch(error){
    console.error('Permissions init failed:', error);
    this.canCreateSampling = false;
    this.canCreateSalesOrder = false;
   }finally{
    this.isLoaded = true;
   }
  }
};

export default Permissions;
